import styled from '@emotion/styled'

export const BottomActionsContainer = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '0.625rem 0px 0.625rem auto',
  flexDirection: 'column',

  'button': {
    marginBottom: '5px !important'
  },

  '>div:first-child': {
    flex: 1
  },

  '@media only screen and (min-width: 600px)': {
    flexDirection: 'row',

    'button': {
      marginBottom: '0px'
    },
  },

  '@media only screen and (min-width: 769px)': {
    flexDirection: 'row',

    'button': {
      marginBottom: '0px'
    },
  },
});